import { Text, Grid, Box, IconButton } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit } from '@fortawesome/pro-regular-svg-icons';

import SectionStartTemplate from '../../../templates/sectionStart';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

function PersonalIntro() {
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      hideProgress={true}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
      proceedLabel="Begin"
      section="How to use this form"
    >
      <Grid
        templateColumns="1fr auto"
        columnGap={4}
        rowGap={8}
        mb={8}
        px={{ base: 4, md: 8 }}
        py={{ base: 4, md: 8 }}
        bgColor="chakra-subtle-bg"
        borderRadius="xl"
      >
        <Box fontSize="lg">
          If your information is correct, <b>approve it with the tick button</b>:
        </Box>

        <IconButton
          aria-label="Confirm (example, not interactive)"
          size="lg"
          icon={<FontAwesomeIcon icon={faCheck} />}
          pointerEvents="none"
        />

        <Box fontSize="lg">
          If it is incorrect, <b>click edit to change it</b> and move on:
        </Box>

        <IconButton
          aria-label="Edit (example, not interactive)"
          size="lg"
          icon={<FontAwesomeIcon icon={faEdit} />}
          pointerEvents="none"
        />
      </Grid>

      <Text fontSize="lg">
        <b>You will also be asked some new questions</b>, please answer accurately.
      </Text>
    </SectionStartTemplate>
  );
}

export default PersonalIntro;
